import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { UploadFileInput, UserInput, Mbti } from "@/gql"
import Dropzone from "@/components/widgets/input/Dropzone.vue"
import PhoneNumberInput from "@/components/widgets/input/PhoneInput.vue"
import { Theme } from "@/types"
import { Genders } from "@/modules/Users/Invitation/constants"
import PasswordInput from "@/components/widgets/input/PasswordInput.vue"
import OutlinedSelect from "@/components/fields/OutlinedSelect.vue"
import { OnboardingFormValues } from "../shared/types"

export type PersonalInfoForm = UserInput & {
  gender?: string | null
  dateOfBirth?: string | null
  currentOccupation?: string | null
  position?: string | null
  residentialAddress?: string | null
  bio?: string | null
  mbti?: string | null
  linkedinUrl?: string | null
  clientAdminPosition?: string | null
  phone?: {
    countryCode: string
    number: string
  }
  password?: string
}

// Define a type for props
interface Props {
  submitBtnLabel: string
  isSubmitting?: boolean
  personalInformation?: PersonalInfoForm | null
  theme?: Theme
  showAvatar?: boolean
  isExistingEmail?: boolean
  showPasswordInput?: boolean
  fields?: string[]
  defaultValues?: OnboardingFormValues["newUserInput"]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfoForm',
  props: {
    submitBtnLabel: null,
    isSubmitting: { type: Boolean },
    personalInformation: null,
    theme: null,
    showAvatar: { type: Boolean },
    isExistingEmail: { type: Boolean },
    showPasswordInput: { type: Boolean },
    fields: null,
    defaultValues: null
  },
  emits: ["submit", "change", "gotoPrev"],
  setup(__props: any, { emit }) {

const props = __props as {
  submitBtnLabel: string
  isSubmitting?: boolean
  personalInformation?: PersonalInfoForm | null
  theme?: Theme
  showAvatar?: boolean
  isExistingEmail?: boolean
  showPasswordInput?: boolean
  fields?: string[]
  defaultValues?: OnboardingFormValues["newUserInput"]
}



const form = ref<PersonalInfoForm>({
  firstName: props.defaultValues?.firstName || "",
  lastName: props.defaultValues?.lastName || "",
  email: props.defaultValues?.email || "",
  avatar: null,
  mbti: null,
  linkedinUrl: null,
  bio: null,
  residentialAddress: null,
  currentOccupation: null,
  dateOfBirth: null,
  gender: null,
})

const showUploadAvatarModal = ref(false)
const avatarPreviewUrl = ref<string | null>(null)
const uploadComplete = ref(false)

const mbtiList = computed(() => Object.values(Mbti))

watch(
  () => props.personalInformation,
  (personalInformation) => {
    if (!personalInformation) return

    form.value = {
      ...form.value,
      ...personalInformation,
    }
  },
  {
    immediate: true,
    deep: true,
  }
)



const observer = ref(null)

const onSubmit = async () => {
  const validity = await (observer.value as any)?.validateWithInfo()
  if (!validity.isValid) return
  emit("change", form.value)
  emit("submit")
}

const onAvatarChange = (file: File[]) => {
  if (file.length) {
    const url = URL.createObjectURL(file[0])
    avatarPreviewUrl.value = url
  }
}

const onFileUploadChange = (uploadedFile: UploadFileInput) => {
  if (uploadedFile?.key) uploadComplete.value = true
}

const onClose = () => {
  showUploadAvatarModal.value = false
  uploadComplete.value = false
}

onMounted(() => {
  form.value = {
    ...form.value,
    ...props.personalInformation,
  }
})

const theme = computed(() => props.theme || { primaryColor: "#000000" })

return { __sfc: true,props, form, showUploadAvatarModal, avatarPreviewUrl, uploadComplete, mbtiList, emit, observer, onSubmit, onAvatarChange, onFileUploadChange, onClose, theme, Icon, Dropzone, PhoneNumberInput, Genders, PasswordInput, OutlinedSelect }
}

})